<app-event-preview-calendar-wrapper
  [months]="months"
  [selectedDate]="activeDay"
  [activeMonthIndex]="activeMonthIndex"
  [lastRecurrenceMessage]="lastRecurrenceMessage"
  [months]="months"
></app-event-preview-calendar-wrapper>
